import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { RequestBuilder } from '../classes/request-builder';
import { ICheckUpd } from '../interfaces/IUserLogin';
import { LoginService } from '../services/login.service';
import { AlertUtil } from '../utils/alert-util';
import { Loading } from '../utils/loading';

@Component({
  selector: 'app-privacy-modal',
  templateUrl: './privacy-modal.component.html',
  styleUrls: ['./privacy-modal.component.css']
})
export class PrivacyModalComponent implements OnInit {
  privacyForm: FormGroup
  userId: string

  constructor(private formBuilder: FormBuilder,
    public config: DynamicDialogConfig,
    private loginService: LoginService,
    private alertUtil: AlertUtil,
    public ref: DynamicDialogRef) {
    //build form group
    this.privacyForm = this.formBuilder.group({
      'acceptOne': [false, Validators.required]
    })
    this.userId = this.config.data.UserId
  }

  // convenience getter for easy access to form fields
  get form() { return this.privacyForm.controls }

  ngOnInit() {
  }

  isAccepted() {
    return this.privacyForm.controls['acceptOne'].value
  }


  /**
   * click GDPR Btn
   */
  onClickGdpr() {
    this.callSetGdprService()
  }


  /**
   * call to set gdpr service
   */
  callSetGdprService() {
    Loading.isLoading = true
    let checkUpd: ICheckUpd = {
      UserId: this.userId
    }
    let reqBuilder = new RequestBuilder(checkUpd)
    this.loginService.updateGDPR(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.data) {
          this.ref.close(response.data)
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

}


